<template>
  <div v-rect-loading="loading" class="company-policy-editor">
    <div class="header">
      <div class="title">{{ headerTitle }}</div>
    </div>
    <div class="content">
      <div class="agreement-style">
        <span class="style-label">{{ $t(`${i18nPrefix}.label.agreementStyle`) }}</span>
        <div class="statement-preview">
          <el-radio v-model="statementType" label="statementPreview" :disabled="disablePreview || isView" @change="handleStatementTypeChange">{{ $t(`${i18nPrefix}.label.statementPreview`) }}</el-radio>
          <div class="direction">
            <div v-show="statementType === 'statementPreview'" class="preview-checked-img">
            </div>
            <div v-show="statementType !== 'statementPreview'" class="preview-no-checked-img">
            </div>
          </div>
        </div>
        <div class="statement-pop-up">
          <el-radio v-model="statementType" label="statementPopUp" :disabled="disablePopUp || isView" @change="handleStatementTypeChange">{{ $t(`${i18nPrefix}.label.statementPop`) }}</el-radio>
          <div class="direction">
            <div v-show="statementType === 'statementPopUp'" class="pop-checked-img">
            </div>
            <div v-show="statementType !== 'statementPopUp'" class="pop-no-checked-img">
            </div>
          </div>
        </div>
      </div>
      <WrappedForm
        v-if="statementType === 'statementPreview'"
        ref="statementPreviewForm"
        class="statement-preview-form"
        label-width="142px"
        :model="previewAgreement"
        :formLines="previewFormLines"
      >
        <template #tinyMceEditor="{ line, lineName }">
          <TinymceEditor v-if="showTinyMce" v-model="previewAgreement[lineName]" :disabled="line.disabled"></TinymceEditor>
        </template>
        <template #uploadFile="{ lineName }">
          <UploadFile v-model="previewAgreement" :dataKey="lineName"></UploadFile>
        </template>
      </WrappedForm>
      <div v-if="statementType === 'statementPopUp'" class="statement-popup-container">
        <WrappedForm
          ref="statementPopupForm"
          class="statement-popup-form"
          label-width="134px"
          :model="popPolicyConfig"
          :formLines="popupFormLines"
          >
          <template #input="{ multipleItem, multipleName }">
            <el-input
              v-model="popPolicyConfig[multipleItem.dataKey[0]][multipleItem.dataKey[1]]"
              v-bind="multipleItem.props"
              :name="multipleName"
              :disabled="multipleItem.disabled"
              :placeholder="multipleItem.placeholder"
            />
          </template>
        </WrappedForm>
        <draggable
          v-model="popAgreementList"
          tag="div"
          handle=".agreement-name-btn .sort-btn"
          animation="200"
          ghostClass="ghost"
          @change="handlePopAgreementChange"
        >
          <div v-for="(popAgreement, popIndex) in popAgreementList" class="agreement-popup-list" :key="popIndex">
            <WrappedForm
              class="agreement-statement-pop-up"
              ref="popAgreementForm"
              label-width="142px"
              :model="popAgreement"
              :formLines="popAgreementFormLines"
            >
              <template #radioGroup="{ line, lineName }">
                <el-radio-group
                  v-model="popAgreement[lineName]"
                  v-bind="line.props"
                  :disabled="line.disabled(popAgreement)"
                >
                  <el-radio
                    v-for="(option, index) in line.option.data"
                    :key="index"
                    :name="lineName"
                    :label="option.value"
                  >
                  {{ option.label }}
                  </el-radio>
                </el-radio-group>
              </template>
              <template #tinyMceEditor="{ line, lineName }">
                <TinymceEditor v-if="showTinyMce" v-model="popAgreement[lineName]" :disabled="line.disabled"></TinymceEditor>
              </template>
              <template #uploadFile="{ lineName }">
                <UploadFile :value="popAgreement" :dataKey="lineName"></UploadFile>
              </template>
            </WrappedForm>
            <div v-show="!isView" class="agreement-name-btn">
              <div class="sort-btn"><i class="el-icon-sort"></i></div>
              <div class="delete-btn" @click="handleDeleteClick(popIndex)"><i class="el-icon-delete"></i></div>
            </div>
          </div>
        </draggable>
        <div v-show="!isView" class="add-pop-up-agreement" @click="handleClickAddPopAgreement">
          <el-divider>{{ $t(`${i18nPrefix}.label.addStatementPopAgreement`) }}</el-divider>
        </div>
      </div>
      <div class="bottom-btn-group">
        <el-button class="cancel-btn" @click="handleBackClick">{{ $t('common.btn.cancel') }}</el-button>
        <el-button v-if="!isView" class="save-btn" @click="handleSavePolicyTos">{{ $t('common.btn.save') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import draggable from 'vuedraggable'
import WrappedForm from '@/components/formEditor/wrappedForm.vue'
import UploadFile from './uploadFile.vue'

export default {
  components: {
    draggable,
    WrappedForm,
    UploadFile,
    TinymceEditor: () => import('./tinymceEditor.vue')
  },
  data () {
    return {
      loading: false,
      i18nPrefix: 'admin.company.agreement',
      statementType: 'statementPreview',
      disablePreview: false,
      disablePopUp: false,
      popPolicyConfig: {
        CONTENT: {
          content_cn: null,
          content_en: null
        },
        BUTTON_SAVE: {
          content_cn: null,
          content_en: null
        },
        BUTTON_CANCEL: {
          content_cn: null,
          content_en: null
        }
      },
      previewAgreement: {
        file_list: [],
        content_cn: null,
        content_en: null,
        percentage: 0,
        agreement_type: 'link',
        agree_cn: null,
        agree_cn_name: null,
        agree_cn_addition: null,
        agreement_cn_link: null,
        file_cn_link: null,
        file_cn_name: null,
        agreement_cn: null,
        agree_en: null,
        agree_en_name: null,
        agree_en_addition: null,
        agreement_en_link: null,
        agreement_en: null,
        file_en_link: null,
        file_en_name: null
      },
      popAgreementList: [{
        file_list: [],
        content_cn: null,
        content_en: null,
        percentage: 0,
        agreement_type: 'link',
        is_notification: false,
        is_satisfaction: false,
        is_required: true,
        agree_cn: null,
        agree_cn_name: null,
        agree_cn_addition: null,
        agreement_cn_link: null,
        file_cn_link: null,
        file_cn_name: null,
        agreement_cn: null,
        agree_en: null,
        agree_en_name: null,
        agree_en_addition: null,
        agreement_en_link: null,
        agreement_en: null,
        file_en_link: null,
        file_en_name: null
      }],
      showTinyMce: false
    }
  },
  computed: {
    isView () {
      return this.$route.meta.isView
    },
    isEdit () {
      return this.$route.meta.isEdit
    },
    rootCompanyId () {
      return this.$route.query.rootCompanyId
    },
    companyId () {
      return this.$route.query.companyId
    },
    policyId () {
      return this.$route.params.policyId
    },
    policyType () {
      return this.$route.query.type
    },
    hasNotificationConfig () {
      return _.some(this.popAgreementList, { is_notification: true })
    },
    hasSatisfactionConfig () {
      return _.some(this.popAgreementList, { is_satisfaction: true })
    },
    headerTitle () {
      const i18nPrefix = `${this.i18nPrefix}.label`
      if (this.isView) {
        return this.$t(`${i18nPrefix}.viewAgreementTitle`)
      } else if (this.isEdit) {
        return this.$t(`${i18nPrefix}.editAgreementTitle`)
      } else {
        return this.$t(`${i18nPrefix}.createAgreementTitle`)
      }
    },
    previewFormLines () {
      const requiredMessage = this.$t('common.message.requiredFormField')
      return {
        content_cn: {
          label: this.$t(`${this.i18nPrefix}.label.agreementCnName`),
          contentSlot: 'tinyMceEditor',
          rules: [{ required: true, message: requiredMessage, trigger: 'blur' }]
        },
        content_en: {
          label: this.$t(`${this.i18nPrefix}.label.agreementEnName`),
          contentSlot: 'tinyMceEditor',
          rules: [{ required: true, message: requiredMessage, trigger: 'blur' }]
        },
        file_list: {
          label: this.$t(`${this.i18nPrefix}.label.agreementFile`),
          contentSlot: 'uploadFile',
          hidden: this.isView
        }
      }
    },
    popupFormLines () {
      const requiredMessage = this.$t('common.message.requiredFormField')
      return {
        popTitle: {
          label: this.$t(`${this.i18nPrefix}.label.popTitle`),
          rules: [{ required: true, validator: this.emptyValidator }],
          hiddenPropName: false,
          multiple: {
            'CONTENT.content_cn': {
              disabled: this.isView,
              placeholder: this.$t(`${this.i18nPrefix}.label.chinese`),
              contentSlot: 'input',
              dataKey: ['CONTENT', 'content_cn'],
              rules: [{ required: true, message: requiredMessage, trigger: 'change' }]

            },
            'CONTENT.content_en': {
              disabled: this.isView,
              placeholder: this.$t(`${this.i18nPrefix}.label.english`),
              contentSlot: 'input',
              dataKey: ['CONTENT', 'content_en'],
              rules: [{ required: true, message: requiredMessage, trigger: 'change' }]
            }
          }
        },
        acceptBtn: {
          label: this.$t(`${this.i18nPrefix}.label.acceptBtn`),
          rules: [{ required: true, validator: this.emptyValidator }],
          multiple: {
            'BUTTON_SAVE.content_cn': {
              disabled: this.isView,
              placeholder: this.$t(`${this.i18nPrefix}.label.chinese`),
              contentSlot: 'input',
              dataKey: ['BUTTON_SAVE', 'content_cn'],
              rules: [{ required: true, message: requiredMessage, trigger: 'change' }]

            },
            'BUTTON_SAVE.content_en': {
              disabled: this.isView,
              placeholder: this.$t(`${this.i18nPrefix}.label.english`),
              contentSlot: 'input',
              dataKey: ['BUTTON_SAVE', 'content_en'],
              rules: [{ required: true, message: requiredMessage, trigger: 'change' }]
            }
          }
        },
        declineBtn: {
          label: this.$t(`${this.i18nPrefix}.label.declineBtn`),
          rules: [{ required: true, validator: this.emptyValidator }],
          multiple: {
            'BUTTON_CANCEL.content_cn': {
              disabled: this.isView,
              placeholder: this.$t(`${this.i18nPrefix}.label.chinese`),
              contentSlot: 'input',
              dataKey: ['BUTTON_CANCEL', 'content_cn'],
              rules: [{ required: true, message: requiredMessage, trigger: 'change' }]

            },
            'BUTTON_CANCEL.content_en': {
              disabled: this.isView,
              placeholder: this.$t(`${this.i18nPrefix}.label.english`),
              contentSlot: 'input',
              dataKey: ['BUTTON_CANCEL', 'content_en'],
              rules: [{ required: true, message: requiredMessage, trigger: 'change' }]
            }
          }
        }
      }
    },
    popAgreementFormLines () {
      const requiredMessage = this.$t('common.message.requiredFormField')
      return {
        is_notification: {
          label: this.$t(`${this.i18nPrefix}.label.notification`),
          disabled: (popAgreement) => this.isView || (!popAgreement.is_notification && this.hasNotificationConfig),
          option: {
            data: [
              { value: true, label: this.$t(`${this.i18nPrefix}.label.yes`) },
              { value: false, label: this.$t(`${this.i18nPrefix}.label.no`) }
            ]
          },
          contentSlot: 'radioGroup',
          rules: [{ required: true, message: requiredMessage, trigger: 'change' }]
        },
        is_satisfaction: {
          label: this.$t(`${this.i18nPrefix}.label.satisfaction`),
          disabled: (popAgreement) => this.isView || (!popAgreement.is_satisfaction && this.hasSatisfactionConfig),
          option: {
            data: [
              { value: true, label: this.$t(`${this.i18nPrefix}.label.yes`) },
              { value: false, label: this.$t(`${this.i18nPrefix}.label.no`) }
            ]
          },
          contentSlot: 'radioGroup',
          rules: [{ required: true, message: requiredMessage, trigger: 'change' }]
        },
        is_required: {
          elType: 'el-radio-group',
          label: this.$t(`${this.i18nPrefix}.label.required`),
          disabled: this.isView,
          option: {
            data: [
              { value: true, label: this.$t(`${this.i18nPrefix}.label.yes`) },
              { value: false, label: this.$t(`${this.i18nPrefix}.label.no`) }
            ]
          },
          rules: [{ required: true, message: requiredMessage, trigger: 'change' }]
        },
        content_cn: {
          label: this.$t(`${this.i18nPrefix}.label.agreementCnName`),
          disabled: this.isView,
          contentSlot: 'tinyMceEditor',
          rules: [{ required: true, message: requiredMessage, trigger: 'change' }]
        },
        content_en: {
          label: this.$t(`${this.i18nPrefix}.label.agreementEnName`),
          disabled: this.isView,
          contentSlot: 'tinyMceEditor',
          rules: [{ required: true, message: requiredMessage, trigger: 'change' }]
        },
        file_list: {
          label: this.$t(`${this.i18nPrefix}.label.agreementFile`),
          hidden: this.isView,
          contentSlot: 'uploadFile'
        }
      }
    }
  },

  created () {
    this.loadData()
  },
  mounted () {
    this.showTinyMce = true
  },
  methods: {
    ...mapActions('agreement', ['getCompanyPolicyById', 'createCompanyPolicy', 'updateCompanyPolicy']),
    async loadData () {
      if (!this.policyId || !this.policyType) {
        return
      }
      this.loading = true
      try {
        if (this.policyType === 'LINK') {
          this.disablePreview = false
          this.disablePopUp = true
        } else {
          this.disablePreview = true
          this.disablePopUp = false
          this.statementType = 'statementPopUp'
        }
        const resp = await this.getCompanyPolicyById(this.policyId)
        if (resp) {
          if (this.policyType === 'LINK') {
            this.previewAgreement = resp
            this.getPolicyLink(this.previewAgreement)
          } else {
            this.popPolicyConfig = resp.pop_policy_config
            this.popAgreementList = resp.pop_policy_list
            _.forEach(this.popAgreementList, policy => {
              this.getPolicyLink(policy)
            })
          }
        }
      } finally {
        this.loading = false
      }
    },
    getPolicyLink (policy) {
      const fileList = []
      const linkList = []
      const regex = /href="(.+?)"/g
      let matches
      while ((matches = regex.exec(policy.content_cn)) !== null) {
        if (!_.includes(linkList, matches[1])) {
          linkList.push(matches[1])
        }
      }
      while ((matches = regex.exec(policy.content_en)) !== null) {
        if (!_.includes(linkList, matches[1])) {
          linkList.push(matches[1])
        }
      }
      _.forEach(linkList, link => {
        const fileName = link.split('/')[8]
        fileList.push({
          file_link: link,
          file_name: fileName,
          isHovering: false
        })
      })
      this.$set(policy, 'file_list', fileList)
    },
    handleStatementTypeChange () {
      if (this.statementType === 'statementPreview') {
        this.popPolicyConfig = {
          CONTENT: {
            content_cn: null,
            content_en: null
          },
          BUTTON_SAVE: {
            content_cn: null,
            content_en: null
          },
          BUTTON_CANCEL: {
            content_cn: null,
            content_en: null
          }
        }
        this.popAgreementList = [{
          file_list: [],
          content_cn: null,
          content_en: null,
          percentage: 0,
          agreement_type: 'link',
          is_notification: false,
          is_satisfaction: false,
          is_required: true,
          agree_cn: null,
          agree_cn_name: null,
          agree_cn_addition: null,
          agreement_cn_link: null,
          file_cn_link: null,
          file_cn_name: null,
          agreement_cn: null,
          agree_en: null,
          agree_en_name: null,
          agree_en_addition: null,
          agreement_en_link: null,
          agreement_en: null,
          file_en_link: null,
          file_en_name: null
        }]
      } else {
        this.previewAgreement = {
          file_list: [],
          content_cn: null,
          content_en: null,
          percentage: 0,
          agreement_type: 'link',
          agree_cn: null,
          agree_cn_name: null,
          agree_cn_addition: null,
          agreement_cn_link: null,
          file_cn_link: null,
          file_cn_name: null,
          agreement_cn: null,
          agree_en: null,
          agree_en_name: null,
          agree_en_addition: null,
          agreement_en_link: null,
          agreement_en: null,
          file_en_link: null,
          file_en_name: null
        }
      }
    },
    handleDeleteClick (index) {
      this.popAgreementList.splice(index, 1)
    },
    handleClickAddPopAgreement () {
      this.popAgreementList.push({
        file_list: [],
        content_cn: null,
        content_en: null,
        percentage: 0,
        agreement_type: 'link',
        is_notification: false,
        is_satisfaction: false,
        is_required: true,
        agree_cn: null,
        agree_cn_name: null,
        agree_cn_addition: null,
        agreement_cn_link: null,
        agree_en: null,
        agree_en_name: null,
        agree_en_addition: null,
        agreement_en_link: null,
        file_cn_link: null,
        file_cn_name: null,
        file_en_link: null,
        file_en_name: null
      })
    },
    handleBackClick () {
      this.$router.push('/v-admin/company-policy-management')
    },
    emptyValidator (rule, value, callback) {
      return callback()
    },
    async handleSavePolicyTos () {
      if (this.isView) {
        return
      }
      let valid = false
      let createParams = null
      let policyContent = null
      if (this.statementType === 'statementPreview') {
        valid = await this.$refs.statementPreviewForm.submit()
        policyContent = this.previewAgreement
        createParams = {
          type: 'LINK',
          policy: this.previewAgreement
        }
      } else {
        valid = await this.$refs.statementPopupForm.submit()
        if (valid) {
          for (let i = 0; i < this.popAgreementList.length; i++) {
            const form = this.$refs.popAgreementForm[i]
            valid = valid && await form.submit()
            this.popAgreementList[i].order = i + 1
          }
        }
        policyContent = {
          policy_list: this.popAgreementList,
          config: this.popPolicyConfig
        }
        createParams = {
          type: 'POPUP',
          policy: this.popAgreementList,
          config: this.popPolicyConfig
        }
      }
      if (!valid) {
        return
      }
      let data = null
      let createOrUpdateMethod = this.createCompanyPolicy
      if (this.isEdit) {
        data = {
          policyId: this.policyId,
          policyInfo: {
            policy_type: this.policyType,
            policy_id: this.policyId,
            policy_content: policyContent
          }
        }
        createOrUpdateMethod = this.updateCompanyPolicy
      } else {
        data = createParams
      }
      this.loading = true
      try {
        const resp = await createOrUpdateMethod(data)
        if (resp) {
          this.$message({
            message: this.$t(`${this.i18nPrefix}.message.${this.isEdit ? 'updateSuccess' : 'createSuccess'}`),
            type: 'success'
          })
          this.$router.push('/v-admin/company-policy-management')
        }
      } finally {
        this.loading = false
      }
      // if (this.policyId && this.policyType) {
      //   let policyContent = null
      //   if (this.statementType === 'statementPreview') {
      //     if (!this.previewAgreement.content_cn || !this.previewAgreement.content_en) {
      //       this.previewAgreementValidate = true
      //       return
      //     }
      //     policyContent = this.previewAgreement
      //   } else {
      //     _.forEach(this.popPolicyConfig, config => {
      //       if (!config.content_cn || !config.content_en) {
      //         this.popPolicyConfigValidate = true
      //         return false
      //       }
      //     })
      //     _.forEach(this.popAgreementList, (policy, index) => {
      //       if (!policy.content_cn || !policy.content_en) {
      //         this.popAgreementListValidate = true
      //         return false
      //       }
      //       policy.order = index + 1
      //     })
      //     policyContent = {
      //       policy_list: this.popAgreementList,
      //       config: this.popPolicyConfig
      //     }
      //   }
      //   const policyInfo = {
      //     policy_type: this.policyType,
      //     policy_id: this.policyId,
      //     policy_content: policyContent
      //   }
      //   const resp = await this.updateCompanyPolicy({
      //     policyId: this.policyId,
      //     policyInfo
      //   })
      //   if (resp) {
      //     this.$message({
      //       message: this.$t(`${this.i18nPrefix}.message.updateSuccess`),
      //       type: 'success'
      //     })
      //   }
      // } else {
      //   let params = null
      //   if (this.statementType === 'statementPreview') {
      //     params = {
      //       type: 'LINK',
      //       policy: this.previewAgreement
      //     }
      //   } else {
      //     params = {
      //       type: 'POPUP',
      //       policy: this.popAgreementList,
      //       config: this.popPolicyConfig
      //     }
      //   }
      //   const resp = await this.createCompanyPolicy(params)
      //   if (resp) {
      //     this.$message({
      //       message: this.$t(`${this.i18nPrefix}.message.createSuccess`),
      //       type: 'success'
      //     })
      //     this.$router.push('/v-admin/company-policy-management')
      //   }
      // }
    },
    handlePopAgreementChange () {
      this.showTinyMce = false
      this.$nextTick(() => {
        this.showTinyMce = true
      })
    }
  },
  watch: {
    '$i18n.locale' () {
      this.showTinyMce = false
      this.$nextTick(() => {
        this.showTinyMce = true
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.company-policy-editor {
  .header {
    border-bottom: 1px solid #e4e7ed;

    .title {
      padding-top: 4px;
      padding-bottom: 18px;
      line-height: 25px;
      font-size: 18px;
      font-weight: 500;
      color: #303133;
    }
  }

  .content {
    width: 720px;
    margin: 30px auto 0;

    .agreement-style {
      display: flex;
      margin-bottom: 20px;

      .style-label {
        width: 128px;
        color: #606266;
        font-size: 14px;
        padding-right: 24px;
        text-align: right;
      }

      .statement-preview {
        flex: 4;
        margin-right: 8px;

        .direction {
          margin-top: 10px;

          .description {
            color: #606266;
            font-size: 14px;
            margin: 10px 0px;
          }

          .example-title {
            margin: 6px 0px;
            color: #606266;
            font-size: 14px;
            font-weight: bold;
          }

          .preview-checked-img {
            height: 120px;
            background-size: contain;
            background-repeat: no-repeat;
            background-image: url(~@/assets/image/agreement/previewChecked.png);
          }

          .preview-no-checked-img {
            height: 120px;
            background-size: contain;
            background-repeat: no-repeat;
            background-image: url(~@/assets/image/agreement/previewNoChecked.png);
          }
        }
      }

      .statement-pop-up {
        flex: 4;

        .direction {
          margin-top: 10px;

          .description {
            color: #606266;
            font-size: 14px;
            margin: 10px 0px;
          }

          .example-title {
            margin: 6px 0px;
            color: #606266;
            font-size: 14px;
            font-weight: bold;
          }

          .pop-checked-img {
            height: 200px;
            background-size: contain;
            background-repeat: no-repeat;
            background-image: url(~@/assets/image/agreement/popChecked.png);
          }

          .pop-no-checked-img {
            height: 200px;
            background-size: contain;
            background-repeat: no-repeat;
            background-image: url(~@/assets/image/agreement/popNoChecked.png);
          }
        }
      }
    }

    .statement-preview-form {
    }

    .statement-popup-container {
      .statement-popup-form {
        ::v-deep {
          .el-input__inner {
            text-overflow: ellipsis;
          }
        }
      }
      .agreement-popup-list {
        display: flex;
        position: relative;
        left: 26px;

        .agreement-statement-pop-up {
          border: 1px dashed #C0C4CC;
          padding: 10px 24px 0 16px;
          margin-top: 10px;
          flex: 1;
        }

        .agreement-name-btn {
          padding: 12px 0px 0px 4px;

          .sort-btn {
            margin-top: 30px;
            font-size: 22px;
            color: #909399;
          }

          .sort-btn :hover {
            color: #0096CC;
            cursor: pointer;
          }

          .delete-btn {
            margin-top: 30px;
            font-size: 22px;
            color: #909399;
          }

          .delete-btn :hover {
            color: #0096CC;
            cursor: pointer;
          }
        }
      }

      .add-pop-up-agreement {
        position: relative;
        left: 14px;
        cursor: pointer;

        ::v-deep {
          .el-divider__text {
            color: #0096CC;
            font-size: 12px;
          }
        }
      }
    }
  }

  .bottom-btn-group {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;

    .el-button {
      padding: 8px 28px;
      border-radius: 2px;
      line-height: 22px;
      font-size: 16px;
      font-weight: 500;
      color: #0096cc;
    }

    .save-btn {
      margin-left: 24px;
      margin-right: 0;
      background: #0096cc;
      border-color: #0096cc;
      color: #ffffff;
    }
  }
}
</style>
